module.exports = __webpack_public_path__ + "media/images/icons/telephone-27ef8fba485859ec21461a7940f5e4b0.svg";